import { TProprties } from '../components/resurs-props/field/types';

export const getDefaultValues = (properties: TProprties) => {
  if (properties) {
    return properties.reduce((acc: { [key: string]: any }, property) => {
      const key = property.key;

      if (property.type === 'multi-select') {
        acc[key] = property.templateOptions.options?.filter(
          (opt) => opt.selected
        );
      } else {
        const value = property.defaultValue;
        acc[key] = value;
      }

      return acc;
    }, {});
  }
};
